import { graphql } from "api/cms-website/generated";

import { TabbedContentHeaderFragment } from "../elements/tabbedContentHeader";
import { TabbedContentTabFragment } from "../elements/tabbedContentTab";

export const TabbedContentFragment = graphql(/* GraphQL */ `
    fragment TabbedContentFragment on ComponentComponentsTabbedContent {
        id
        noMarginBottom
        type
        rating
        disclaimer
        showMoreButtonLabel
        header(pagination: { limit: 100 }) {
            ...TabbedContentHeaderFragment
        }
        tabs(pagination: { limit: 100 }) {
            ...TabbedContentTabFragment
        }
    }
    ${TabbedContentHeaderFragment}
    ${TabbedContentTabFragment}
`);
